import {
    DynamicPriceRulesEntityId,
    DynamicPriceRulesPropertyId,
} from '@modules/bcm/products/product/dynamic-price-rules-builder/models/dynamic-price-rules-entity-id';
import { DynamicPriceRulesFieldType } from '@modules/bcm/products/product/dynamic-price-rules-builder/models/dynamic-price-rules-field-type';
import { DynamicPriceRulesQueryOperator } from '@modules/bcm/products/product/dynamic-price-rules-builder/models/dynamic-price-rules-query-operator';
import { DynamicPriceRoundingId } from '@modules/bcm/products/product/shared/dynamic-price-rounding-id';
import {
    DynamicPriceCalculationsEntityId,
    DynamicPriceCalculationsPropertyId,
} from '@modules/bcm/products/product/dynamic-price-calculations-builder/models/dynamic-price-calculations-entity-id';
import { DynamicPriceCalculationsOperator } from '@modules/bcm/products/product/dynamic-price-calculations-builder/models/dynamic-price-calculations-operator';

export enum ConditionNodeType {
    Group = 'group',
    Leaf = 'leaf',
}

// Xor = "exactly one of the children is true"
export enum BooleanOperator {
    And = 'and',
    Or = 'or',
    Xor = 'xor',
}

export interface ConditionLeaf {
    type: ConditionNodeType.Leaf;
    entityId: DynamicPriceRulesEntityId;
    fieldProperty?: DynamicPriceRulesPropertyId;
    fieldType: DynamicPriceRulesFieldType;
    roundingId?: DynamicPriceRoundingId;
    operator: DynamicPriceRulesQueryOperator;
    value: any;
    negate?: boolean;
}

export interface ConditionBranch {
    type: ConditionNodeType.Group;
    operator: BooleanOperator;
    negate?: boolean;
    children: ConditionNode[];
}

export type ConditionNode = ConditionLeaf | ConditionBranch;

export interface DynamicPriceFactor {
    entityId: DynamicPriceCalculationsEntityId;
    fieldProperty: DynamicPriceCalculationsPropertyId;
    roundingId?: DynamicPriceRoundingId;
    operator: DynamicPriceCalculationsOperator;
}

export interface DynamicPriceGroup {
    name?: string;
    collapsed?: boolean;
    condition: ConditionNode | null;
    basePrice: number;
    factors: DynamicPriceFactor[];
    // Set by the legacy→groups converter: per-step rounding for byte-for-byte parity.
    legacyRoundingCompat?: boolean;
}

export enum GroupCombineOperator {
    Sum = 'sum',
}

export interface LegacySnapshot {
    ruleSets: unknown;
    calculationSets: unknown;
    productPriceAtConversion: number;
    convertedOn: string;
    convertedBy: string;
    // Set on revert; absence means the snapshot still represents an active convert. A subsequent
    // re-convert overwrites the whole snapshot (intentional: snapshot's job is "pre-this-convert
    // state", not a cross-cycle history log).
    revertedOn?: string;
    revertedBy?: string;
}
